// Shared limits for part prices. Used to cap the price a user can enter or
// update anywhere a part is priced (creation, basket, unlisted table, bulk update).
export const MAX_PART_PRICE = 10000;

// Returns true when the value is a valid, non-negative price within the allowed cap.
export const isValidPartPrice = (price: number): boolean =>
  !Number.isNaN(price) && price >= 0 && price <= MAX_PART_PRICE;
